<template>
    <div v-if="loading"></div>
    <div v-else>
        <v-dialog v-model="dialog" persistent max-width="800px" light>
            <v-card color="rgb(255, 0, 0, 0.2)">
                <v-toolbar class="custom-font-regular requerimiento-toolbar" color="#dedfe4">
                    <v-toolbar-title>Consulta</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items right>
                        <v-btn icon @click="hideDialog"><v-icon>close</v-icon></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="body-content">
                    <div>
                        Derivar consulta {{ consulta.title }} al departamento:
                    </div>
                    <v-spacer></v-spacer>
                    <v-select v-model="departamento"
                              :items="items"
                              item-text="nombre"
                              item-value="id"
                              :error-messages="departamentoErrors"
                              label="Departamento" required @change="$v.departamento.$touch()"
                              no-data-text="No hay datos disponibles">
                    </v-select>
                </v-card-text>
                <v-card-actions class="buttons-content">
                    <v-btn color="error" flat @click="hideDialog">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat  @click="derivarConsulta()" :disabled="loading || !isValid">Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  props: {
    consulta: Object
  },

  validations: {
    departamento: { required }
  },

  data () {
    return {
      loading: false,
      dialog: true,
      currentDepartment: this.consulta.departamento,
      departamento: 0,
      items: [],
      editPath: 'consulta/derivar'
    }
  },

  computed: {
    isValid () {
      let currentDepartmentItem = this.items.filter(depto => depto.nombre === this.currentDepartment)
      return this.departamento !== currentDepartmentItem[0].id
    },
    departamentoErrors () {
      const errors = []
      if (!this.$v.departamento.$dirty) return errors
      !this.$v.departamento.required && errors.push('El departamento es requerido.')
      return errors
    }
  },
  methods: {
    fetchData () {
      this.axios
        .get('departamento')
        .then(response => {
          this.items = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    hideDialog () {
      this.$emit('hideDerivarDialog')
    },
    getPayload () {
      let payload = {}
      payload.departamento = this.departamento
      return payload
    },
    derivarConsulta () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let payload = this.getPayload()
        this.axios
          .put(`${this.editPath}/${this.consulta.id}`, payload)
          .then((response) => {
            this.$emit('updateConsulta')
            this.loading = false
            this.$router.push({ name: 'consultas' })
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.loading = false
          })
      }
    }
  },

  created () {
    this.loading = true
    this.fetchData()
  }
}
</script>

<style scoped>
    .custom-font-regular {
        font-family: SourceSansProRegular, sans-serif;
    }

    .body-content {
        padding: 30px;
        background-color: #e9eaec;
    }

    .buttons-content {
        padding: 1em 0.5em 0.5em 0.5em;
        background-color: #e9eaec;
    }
</style>
